import { useApiDataService } from './use-api-data-service';
import { MemberService } from 'services/member-service';

export const useMemberService = () => useApiDataService<MemberService>(MemberService);
export default useMemberService;
